import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { StaffState } from "../../types/features/staffSlice";
import {
  createStaffService,
  deleteStaffService,
  fetchStaffTable,
  updateStaffService,
} from "../../api/staffApi";

export const getStaffData = createAsyncThunk<
  any,
  { page: number; limit: number }
>("staff/getStaffData", async ({ page, limit }) => {
  const response = await fetchStaffTable({ page, limit });
  return response.data;
});

export const createStaffData = createAsyncThunk<any, { data: any }>(
  "staff/createStaffData",
  async ({ data }) => {
    const response = await createStaffService(data);
    return response.data;
  }
);

export const updateStaffData = createAsyncThunk<
  any,
  { id: string; data: any }
>("staff/updateStaffData", async ({ id, data }) => {
  const response = await updateStaffService({ id, data });
  return response.data;
});

export const deleteStaffData = createAsyncThunk<any, { id: string }>(
  "staff/deleteStaffData",
  async ({ id }) => {
    const response = await deleteStaffService({ id });
    return response.data;
  }
);

const StaffSlice = createSlice({
  name: "staff",
  initialState: {
    staffLoader: false,
    status: false,
    msg: "",
    data: null,
    detail: null,
    pagination: null,
  } as StaffState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStaffData.pending, (state) => {
        state.staffLoader = true;
      })
      .addCase(getStaffData.fulfilled, (state, action: PayloadAction<any>) => {
        state.data = action.payload.data;
        state.pagination = action.payload.pagination || null;
        state.msg = action.payload.message;
        state.status = true;
        state.staffLoader = false;
      })
      .addCase(getStaffData.rejected, (state, action) => {
        state.staffLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(createStaffData.pending, (state) => {
        state.staffLoader = true;
      })
      .addCase(
        createStaffData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.msg = action.payload.message;
          state.status = true;
          state.staffLoader = false;
        }
      )
      .addCase(createStaffData.rejected, (state, action) => {
        state.staffLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(updateStaffData.pending, (state) => {
        state.staffLoader = true;
      })
      .addCase(
        updateStaffData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.msg = action.payload.message;
          state.status = true;
          state.staffLoader = false;
        }
      )
      .addCase(updateStaffData.rejected, (state, action) => {
        state.staffLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(deleteStaffData.pending, (state) => {
        state.staffLoader = true;
      })
      .addCase(
        deleteStaffData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.msg = action.payload.message;
          state.status = true;
          state.staffLoader = false;
        }
      )
      .addCase(deleteStaffData.rejected, (state, action) => {
        state.staffLoader = false;
        state.status = false;
        state.msg = action.error.message;
      });
  },
});

export default StaffSlice.reducer;